export const PROMPT_COLORS = {
  cherry: {
    primaryColor: "#FF4447",
    secondaryColor: "#FF4447",
    textColor: "#FFFFFF"
  },
  blush: {
    primaryColor: "#FFC1C2",
    secondaryColor: "#FF4447",
    textColor: "#FF4447"
  },
  gold: {
    primaryColor: "#F4D430",
    secondaryColor: "#F4D430",
    textColor: "#FFFFFF"
  },
  daffodil: {
    primaryColor: "#FBEEAC",
    secondaryColor: "#F4D430",
    textColor: "#9B7600"
  },
  lake: {
    primaryColor: "#2AB1A8",
    secondaryColor: "#2AB1A8",
    textColor: "#FFFFFF"
  },
  mint: {
    primaryColor: "#B8E5E2",
    secondaryColor: "#2AB1A8",
    textColor: "#2AB1A8"
  },
  sky: {
    primaryColor: "#487ADF",
    secondaryColor: "#487ADF",
    textColor: "#FFFFFF"
  },
  hydrangeas: {
    primaryColor: "#D3DFF7",
    secondaryColor: "#487ADF",
    textColor: "#487ADF"
  },
  grey: {
    primaryColor: "#E4E4E4",
    secondaryColor: "#A0A0A0",
    textColor: "#A0A0A0"
  },
  primary: {
    primaryColor: "#9A8AC2",
    secondaryColor: "#9A8AC2",
    textColor: "#FFFFFF"
  }
};

export const PROMPT_POINTS = {
  square: { pointStyle: "rectRounded" },
  circle: { pointStyle: "circle" },
  triangle: { pointStyle: "triangle" },
  diamond: { pointStyle: "rectRot" }
};

export const PHASE_LINE_COLORS = {
  lake: "#2AB1A8",
  tangerine: "#F57E00",
  cherry: "#FF4447",
  sky: "#487ADF",
  moss: "#A7C957",
  gold: "#F4D430",
  salmon: "#F4855D",
  primary: "#9A8AC2"
};

export const CLOCK_ROUND = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00"
];

export const CLOCK_HALF = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
  "24:00",
  "24:30"
];



// WEBPACK FOOTER //
// ./src/plugins/assets.js